(function () {
  var style = document.createElement('style');
  style.textContent = '.cart-discount__pill-remove{display:flex;align-items:center;justify-content:center;min-width:28px;min-height:28px;padding:6px;border-radius:50%;background-color:rgba(0,0,0,0.08);cursor:pointer;flex-shrink:0;transition:background-color .15s ease}.cart-discount__pill-remove:hover,.cart-discount__pill-remove:active{background-color:rgba(220,38,38,0.15)}.cart-discount__pill-remove svg{width:12px;height:12px;opacity:1}';
  document.head.appendChild(style);

  var CASE_PRODUCT_ID = 8246306799734;
  var GIFT_IDS = [44066383102070, 43699763347574, 44066393981046];
  var FREE_SHIP_CODE = 'FREESHIPCASE';
  var isProcessing = false;

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addGifts(missingIds) {
    if (missingIds.length === 0) return Promise.resolve();
    var items = missingIds.map(function (id) { return { id: id, quantity: 1, properties: { '_free_gift': 'B1G1PLUS3GIFTS' } }; });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  function applyFreeShipping() {
    if (sessionStorage.getItem('free_ship_applied') === FREE_SHIP_CODE) return Promise.resolve();
    return fetch('/discount/' + FREE_SHIP_CODE, { credentials: 'include' })
      .then(function () {
        sessionStorage.setItem('free_ship_applied', FREE_SHIP_CODE);
      })
      .catch(function (err) { console.error('Free shipping apply failed:', err); });
  }

  function checkAndAddGifts() {
    if (isProcessing) return;
    isProcessing = true;
    fetchCart().then(function (cart) {
      var hasCase = cart.items.some(function (item) { return item.product_id === CASE_PRODUCT_ID; });
      if (!hasCase) { isProcessing = false; return; }

      var presentVariantIds = cart.items.map(function (item) { return item.variant_id; });
      var missingGiftIds = GIFT_IDS.filter(function (id) { return presentVariantIds.indexOf(id) === -1; });

      var alreadyShipApplied = sessionStorage.getItem('free_ship_applied') === FREE_SHIP_CODE;

      var tasks = [];
      if (missingGiftIds.length > 0) tasks.push(addGifts(missingGiftIds));
      if (!alreadyShipApplied) tasks.push(applyFreeShipping());

      Promise.all(tasks).then(function () {
        return fetchCart();
      }).then(function (cart) {
        var cartCountEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble');
        cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (!alreadyShipApplied && tasks.length > (missingGiftIds.length > 0 ? 1 : 0)) {
          // Reload once so the price/shipping reflects the newly applied discount code
          if (!sessionStorage.getItem('free_ship_reloaded')) {
            sessionStorage.setItem('free_ship_reloaded', '1');
            window.location.reload();
          }
        }
      }).finally(function () { isProcessing = false; });
    }).catch(function () { isProcessing = false; });
  }

  document.addEventListener('DOMContentLoaded', checkAndAddGifts);
  document.addEventListener('cart:updated', checkAndAddGifts);
  document.addEventListener('cart:build', checkAndAddGifts);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      setTimeout(checkAndAddGifts, 800);
      setTimeout(checkAndAddGifts, 1800);
    }
  });
})();
